export const iconFontAwesomeLogisticsBridge = (
	<i className="fa-solid fa-bridge"></i>
);
